var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "invoice-card", style: { "border-color": _vm.statusColor } },
    [
      _c("q-card-title", { staticClass: "invoice-card__title-wrapper" }, [
        _c(
          "span",
          {
            staticClass: "invoice-card__status",
            style: { "background-color": _vm.statusColor }
          },
          [_vm._v(_vm._s(_vm.$t(_vm.quote.status)))]
        ),
        _c(
          "span",
          { staticClass: "invoice-card__title" },
          [
            _vm.quote.status !== "draft"
              ? _c(
                  "router-link",
                  {
                    staticClass: "router-link",
                    attrs: {
                      to: {
                        name: "quote",
                        params: {
                          quote: _vm.quote.id,
                          teamId: _vm.activeTeam.id
                        }
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n         " +
                        _vm._s(_vm.$tc("quote", 1)) +
                        "\n         "
                    ),
                    _vm.quote.quote_number
                      ? [
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v("#" + _vm._s(_vm.quote.quote_number))
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$tc("quote", 1)) +
                      "\n          "
                  ),
                  _vm.quote.quote_number
                    ? [
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v("#" + _vm._s(_vm.quote.quote_number))
                        ])
                      ]
                    : _vm._e()
                ]
          ],
          2
        )
      ]),
      _c("q-card-main", { staticClass: "invoice-card__main" }, [
        _c("div", { staticClass: "invoice-card__meta" }, [
          _c("div", { staticClass: "invoice-card__entry" }, [
            _c("h5", { staticClass: "invoice-card__entry-heading" }, [
              _vm._v(_vm._s(_vm.$tc("customer", 1)))
            ]),
            _c(
              "span",
              { staticClass: "invoice-card__entry-value" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "router-link",
                    attrs: {
                      to: {
                        name: "customer",
                        params: {
                          customerId: _vm.customer.id,
                          teamId: this.activeTeam.id
                        }
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.customerName) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "invoice-card__entry" }, [
            _c("h5", { staticClass: "invoice-card__entry-heading" }, [
              _vm._v(_vm._s(_vm.$t("valid_until")))
            ]),
            _c("span", { staticClass: "invoice-card__entry-value" }, [
              _vm._v(_vm._s(_vm.validUntil))
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "invoice-card__row invoice-card__row--bottom" },
          [
            _c(
              "div",
              {
                staticClass: "invoice-card__entry invoice-card__entry--center"
              },
              [
                _c("h5", { staticClass: "invoice-card__entry-heading" }, [
                  _vm._v(_vm._s(_vm.$t("sum_gross")))
                ]),
                _c(
                  "span",
                  {
                    staticClass:
                      "invoice-card__entry-value invoice-card__entry-value--big"
                  },
                  [_vm._v(_vm._s(_vm.totalGross))]
                )
              ]
            )
          ]
        )
      ]),
      _c("q-card-actions", { staticClass: "invoice-card__actions" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            !_vm.isDraft
              ? _c("q-btn", {
                  attrs: { flat: "", dense: "", icon: "visibility" },
                  on: { click: _vm.handleView }
                })
              : _vm._e(),
            _vm.isDraft
              ? _c("q-btn", {
                  attrs: { flat: "", dense: "", icon: "edit" },
                  on: { click: _vm.handleEdit }
                })
              : _vm._e(),
            !_vm.isDraft
              ? _c("q-btn", {
                  attrs: { flat: "", dense: "", icon: "receipt" },
                  on: { click: _vm.handleCreateInvoice }
                })
              : _vm._e(),
            _vm.isDraft
              ? _c("q-btn", {
                  attrs: { flat: "", dense: "", icon: "delete" },
                  on: { click: _vm.handleRemove }
                })
              : _vm._e(),
            !_vm.isDraft
              ? _c("q-btn", {
                  attrs: { flat: "", dense: "", icon: "cloud_download" },
                  on: { click: _vm.handlePdfDownload }
                })
              : _vm._e()
          ],
          1
        ),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            { staticClass: "row justify-end" },
            [
              _c("q-checkbox", {
                class: [
                  "invoice-card__actions__select",
                  { block: _vm.selected }
                ],
                on: {
                  input: function($event) {
                    _vm.$emit("select", $event)
                  }
                },
                model: {
                  value: _vm.selected,
                  callback: function($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }